var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValuepropsTag2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 50,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeWidth: 0.25,
  d: "M20.57.875c.147 0 .289.058.392.161l.068.085c.06.09.093.198.093.307V9.34a.55.55 0 0 1-.093.306l-.068.084-9.232 9.232a.55.55 0 0 1-.265.144v.019h-.125a.55.55 0 0 1-.307-.093l-.084-.068-7.913-7.914a.556.556 0 0 1 0-.783v-.001l9.232-9.23.084-.068a.56.56 0 0 1 .306-.093zM4.21 10.659l7.129 7.13 8.678-8.679V1.981h-7.13z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeWidth: 0.25,
  d: "M18.013 3.233c.242 0 .433.096.56.245A.8.8 0 0 1 18.76 4a.8.8 0 0 1-.185.524.72.72 0 0 1-.56.245.72.72 0 0 1-.561-.245.8.8 0 0 1-.186-.524c0-.186.06-.377.186-.523a.72.72 0 0 1 .56-.245Z"
})));
export default SvgValuepropsTag2;